import React from "react";
import ProfileProvider from "./ProfileContext";

function ContextProvider({ children }) {
  return <ProfileProvider>{children}</ProfileProvider>;
}

export default ContextProvider;
